import { dispatch } from 'modules/core/lib/pubSub'

import { REFETCH_DATA_EVENT } from 'modules/finance/components/FinancialWorkspace/components/Table/const'
import { UploadPayrollButton } from 'modules/finance/components/FinancialWorkspace/components/UploadPayroll'

const SOURCE = 'fw-payroll-header'

export const Uploadpayroll = ({ variant }: { variant?: string }) => {
  const onFinishPayroll = () => {
    dispatch({ type: REFETCH_DATA_EVENT })
  }

  return (
    <UploadPayrollButton
      type="default"
      source={SOURCE}
      variant={variant}
      includeButtonIcon
      version="factorial-one"
      onFinish={onFinishPayroll}
    />
  )
}
